import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IResults, IServiceError, IServerSettings } from '../models/index';

@Injectable()
export class FeatureService{

  baseUrl: string = '';

  constructor(private http: HttpClient, private authService: AuthenticationService, @Inject('BASE_URL') baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  public IsFeatureEnabled(name: string): Observable<boolean>{

    let url = `${this.baseUrl}FeatureFlag?name=${name}`;
    let headers = this.authService.setHeader();

    return this.http.get<boolean>(url, { headers: headers });
  }

  private handleHttpError(error: HttpErrorResponse): Observable<IServiceError> {

    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      const dataError = new IServiceError();
      dataError.errorNumber = error.error ? error.error.number : '';
      dataError.message = error.message;
      dataError.friendlyMessage = error.status ? `Http call failed with status ${error.status}` : `Http call failed`;
      dataError.errorMessage = error.error ? error.error.message : '';
      dataError.errorStatus = error.status;
      dataError.url = error.url;

      // return an observable of an IServiceError object with a user friendly error message
      return of(dataError);
    }
  }

}
